import * as types from './types';
import { createRoutine, promisifyRoutine } from 'redux-saga-routines';

export const createVenue = createRoutine(types.CREATE_VENUE);
export const sumbmitCreateVenueForm = promisifyRoutine(createVenue);
